import API from "../config/api.js";

export const ProjectService = {
  getProjectRegionClubs(id, search) {
    return API.get(`api/service-project/${id}/region-clubs/se=${search}`);
  },

  createProjectInfo(data) {
    return API.post(`api/service-project/info/save`, data);
  },

  createProjectClubContribution(data) {
    return API.post(`api/service-project/clubs-contribution/save`, data);
  },

  getProjectClubContribution(id) {
    return API.get(`api/service-project/${id}/clubs-contribution/list`);
  },

  createGovernorThemes(data) {
    return API.post(`api/service-project/district-governor-theme/save`, data);
  },

  getGovernorThemeList(id) {
    return API.get(`api/service-project/${id}/district-governor-theme/list`);
  },

  deleteProjectGovernorTheme(id) {
    return API.delete(
      `api/service-project/DISTRICT_GOVERNOR_THEME/${id}/delete`
    );
  },

  deleteProjectCommittee(id) {
    return API.delete(`api/service-project/PROJECT_COMMITTEE/${id}/delete`);
  },

  deleteProjectClubContribution(id) {
    return API.delete(`api/service-project/PROJECT_CONTRIBUTION/${id}/delete`);
  },

  deleteProjectParticipant(id) {
    return API.delete(`api/service-project/PROJECT_PARTICIPANT/${id}/delete`);
  },

  update(id, data) {
    return API.post(`api/service-project/${id}/update`, data);
  },

  updateInfo(id, data) {
    return API.post(`api/service-project/${id}/update-info`, data);
  },

  getParticipantList(id) {
    return API.get(`api/service-project/${id}/participant/list`);
  },

  createParticipant(data) {
    return API.post(`api/service-project/participant/save`, data);
  },

  createCommitteeMembers(data) {
    return API.post(`api/service-project/committee-member/save`, data);
  },

  getCommitteeMemberList(id) {
    return API.get(`api/service-project/${id}/committee-member/list`);
  },

  documentUpload(id, data) {
    return API.post(`api/service-project/${id}/document`, data);
  },

  getProjectInfo(id) {
    return API.get(`api/service-project/${id}/info`);
  },

  getProjectList(search, page=1) {
    return API.get(`api/service-project/list/se=${search}?page=${page}`);
  },

  checkCanApproval(id) {
    return API.get(`api/service-project/${id}/approve-user`);
  },

  updateApproval(id, data) {
    return API.post(`api/service-project/${id}/approve-update`, data);
  },

  statusPending(id, data) { 
    return API.post(`api/service-project/${id}/pending`, data);
  },

  delete(id) { 
    return API.delete(`api/service-project/${id}/delete`);
  },

  updateContribution(id, data) { 
    return API.post(`api/service-project-contribution/${id}/update`, data);
  },

  updatePointsStatus(data) { 
    return API.post(`api/project-points/update-status`, data);
  },

  refreshPoints(uuid) { 
    return API.post(`api/service-project/${uuid}/point-calculate`);
  },


  downloadReports(type, month,  header) { 
    return API.get(`api/service-project/${month}/reports/${type}`, header);
  },

  
  updateProjectPoints(uuid, data) { 
     return API.post(`api/service-project/${uuid}/point-update`, data);
  },

  downloadProjectSummaryReports(uuid, header) { 
     return API.get(`api/service-project/summary/${uuid}/reports`, header);
  },

  getProjectClubReport(clubId,  header) { 
    return API.get(`api/service-project/${clubId}/club-reports`, header);
  },


  
};
